<div class="hr-separator"><hr></div>
<nz-spin [nzSpinning]="isLoading"></nz-spin>

<ng-container *ngIf="!isLoading && data">
  <div class="row">
    <div class="col col-lg-12">
      <table class="table table-borderless">
        <tr>
          <td class="fs-12 pt-1 pb-1 px-0 pe-0">Activ. Date: <strong>{{ data?.activation_date | niceDate : '-' : true }}</strong></td>
          <td class="fs-12 pt-1 pb-1 px-0 pe-0">Compl. Date: <strong>{{ data?.completion_date | niceDate : '-' : true }}</strong></td>
          <td class="fs-12 pt-1 pb-1 px-0 pe-0">Status: <strong>{{ data?.status | nullAsWhatever : '-' }}</strong></td>
          <td class="fs-12 pt-1 pb-1 px-0 pe-0">Type: <strong>{{ data?.type | nullAsWhatever : '-' }}</strong></td>
          <td class="fs-12 pt-1 pb-1 px-0 pe-0">Due Date: <strong>{{ data?.due_date | niceDate : '-' : true }}</strong></td>
        </tr>
      </table>
    </div>

    <div class="w-100">
      <ul ngbNav #nav="ngbNav" [destroyOnHide]="false" class="nav-tabs">
        <!-- EQUIPMENT TAG -->
        <li [ngbNavItem]="1">
          <a ngbNavLink class="text-dark font-weight-bold border-start-0" style="border-top-left-radius: 0">Description</a>
          <ng-template ngbNavContent>
            <div class="pt-3 px-3 pe-3 pb-0 mt-0">
              {{ data?.description }}
            </div>
          </ng-template>
        </li>
        <!-- EQUIPMENT TAG -->

        <!-- DESCRIPTION -->
        <li [ngbNavItem]="2">
          <a ngbNavLink class="text-dark font-weight-bold">Equipment Tag</a>
          <ng-template ngbNavContent>
            <div [ngClass]="{'pt-3 pe-3 px-3 pb-0 mt-0': true, 'scrollable-container': false}">
              <ng-container *ngIf="data.equipment_tags.length > 0">
                <table class="table table-borderless mb-0 transparent-head">
                  <thead>
                    <tr>
                      <th class="fs-12 pt-1 pb-1 px-0 pe-0 border-light">TagName</th>
                      <th class="fs-12 pt-1 pb-1 px-0 pe-0 border-light">Description</th>
                      <ng-container *ngIf="data?.type === 'PM03'">
                        <th class="fs-12 pt-1 pb-1 px-0 pe-0 border-light">Activity</th>
                        <th class="fs-12 pt-1 pb-1 px-0 pe-0 border-light text-center">Completed</th>
                      </ng-container>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let equipmentTag of data.equipment_tags; let i = index">
                      <tr>
                        <td class="fs-12 pt-1 pb-1 px-0 pe-0">
                          <span class="clickable" (click)="onDataCardDrawerOpen(equipmentTag.tag)">
                            {{ equipmentTag.tag }}
                          </span>
                        </td>
                        <td class="fs-12 pt-1 pb-1 px-0 pe-0">
                          {{ equipmentTag.description | nullAsWhatever : '-' }}
                        </td>
                        <ng-container *ngIf="data?.type === 'PM03'">
                          <td class="fs-12 pt-1 pb-1 px-0 pe-0">
                            <ng-container *ngIf="equipmentTag.is_fe">
                              {{ equipmentTag.activity_codes.join(', ') | nullAsWhatever : '-' }}
                            </ng-container>
                          </td>
                          <td class="fs-12 pt-1 pb-1 px-0 pe-0 text-center">
                            <app-is-checked
                              [show]="equipmentTag.is_fe"
                              [isChecked]="!!equipmentTag.completed_status"></app-is-checked>
                          </td>
                        </ng-container>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </ng-container>
            </div>
          </ng-template>
        </li>
        <!-- DESCRIPTION -->
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-0"></div>
    </div>
  </div>
</ng-container>
